module.exports = __webpack_public_path__ + "static/img/left-resting-hand.aa9939cd.png";